import { useEffect, useRef, useState } from 'react';

import { api, ApiClientError } from '../../services/api';
import useAuth from '../../hooks/useAuth';

type Props = {
  token: string;
  onSuccess: () => void;
};

type LinkState = 'consuming' | 'success' | 'error';

const LinkDevice = ({ token, onSuccess }: Props) => {
  const [state, setState] = useState<LinkState>('consuming');
  const [error, setError] = useState<string | null>(null);
  const { refresh } = useAuth();
  const consumedRef = useRef(false);

  useEffect(() => {
    if (consumedRef.current) return;
    consumedRef.current = true;

    const consume = async () => {
      try {
        await api.consumeQrSession(token);
        setState('success');
        await refresh();
        setTimeout(() => {
          window.location.hash = '';
          onSuccess();
        }, 1_500);
      } catch (reason) {
        setState('error');
        setError(
          reason instanceof ApiClientError
            ? reason.message
            : 'Apparaat kon niet worden gekoppeld.',
        );
      }
    };
    void consume();
  }, [token, refresh, onSuccess]);

  return (
    <main className="auth-page">
      <div className="auth-background" aria-hidden="true" />
      <div className="auth-column">
        <section className="auth-card">
          <div className="brand-mark" aria-hidden="true">
            AI
          </div>
          {state === 'consuming' && (
            <>
              <h1>Apparaat koppelen</h1>
              <p className="muted">Bezig met koppelen aan je account…</p>
              <div className="loading-line" aria-label="Koppelen" />
            </>
          )}
          {state === 'success' && (
            <>
              <h1>Apparaat gekoppeld</h1>
              <p className="notice success">
                Je apparaat is succesvol gekoppeld. Je wordt doorgestuurd…
              </p>
            </>
          )}
          {state === 'error' && (
            <>
              <h1>Koppelen mislukt</h1>
              {error && <p className="notice error">{error}</p>}
              <p className="muted">
                De QR-code is mogelijk verlopen of al gebruikt. Vraag een nieuwe
                QR-code aan op je andere apparaat.
              </p>
              <button
                type="button"
                className="button primary"
                onClick={() => {
                  window.location.hash = '';
                  onSuccess();
                }}
              >
                Naar inloggen
              </button>
            </>
          )}
        </section>
      </div>
    </main>
  );
};

export default LinkDevice;
